var _symbol, _symbol2, _symbol3, _symbol4, _symbol5, _symbol6, _symbol7, _symbol8, _symbol9, _symbol0, _symbol1, _symbol10, _symbol11, _symbol12, _symbol13, _symbol14, _symbol15, _symbol16, _symbol17, _symbol18, _symbol19, _symbol20, _symbol21, _symbol22, _symbol23, _symbol24;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOntarioIconsPrimary(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      display: "none"
    },
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "ontario-icon-accessibility"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.4 11.2l-4.1.2 2.3-2.6c.2-.3.3-.8.2-1.3-.1-.3-.2-.6-.5-.8l-5.4-3.2c-.4-.3-1-.2-1.4.1L6.8 6.1c-.5.5-.6 1.2-.1 1.7.4.5 1.2.5 1.7.1l2-1.8 1.9 1.1-4.2 4.3c-.1.1-.1.2-.2.2-.5.2-1 .4-1.4.7L8 13.9c.5-.2 1-.4 1.5-.4 1.9 0 3.5 1.6 3.5 3.5 0 .6-.1 1.1-.4 1.5l1.5 1.5a5.29 5.29 0 00.9-3c0-1.2-.4-2.4-1.1-3.3l3.3-.3-.2 4.8c-.1.7.4 1.2 1.1 1.3h.1c.6 0 1.1-.5 1.2-1.1l.2-5.9c0-.3-.1-.7-.3-.9-.3-.3-.6-.4-.9-.4zM18 5.5a2 2 0 002-2 2 2 0 00-2-2 2 2 0 00-2 2 2 2 0 002 2zm-5.5 16.1a5.29 5.29 0 01-3 .9C6.5 22.5 4 20 4 17a5.29 5.29 0 01.9-3l1.5 1.5c-.2.5-.4 1-.4 1.5 0 1.9 1.6 3.5 3.5 3.5.6 0 1.1-.1 1.5-.4l1.5 1.5z",
    fill: ""
  }))), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    id: "ontario-icon-add-alt"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11h-4v4h-2v-4H7v-2h4V7h2v4h4v2z",
    fill: ""
  }))), _symbol3 || (_symbol3 = /*#__PURE__*/React.createElement("symbol", {
    id: "ontario-icon-add"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4V7zm-1-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.4 0-8-3.6-8-8s3.6-8 8-8 8 3.6 8 8-3.6 8-8 8z",
    fill: ""
  }))), _symbol4 || (_symbol4 = /*#__PURE__*/React.createElement("symbol", {
    id: "ontario-icon-alert-error"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z",
    fill: "#cd0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 17h2v-2h-2v2zm0-4h2V7h-2v6z",
    fill: "#fff"
  }))), _symbol5 || (_symbol5 = /*#__PURE__*/React.createElement("symbol", {
    id: "ontario-icon-alert-information"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z",
    fill: "#1080a6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 17h2v-6h-2v6zm0-8h2V7h-2v2z",
    fill: "#fff"
  }))), _symbol6 || (_symbol6 = /*#__PURE__*/React.createElement("symbol", {
    id: "ontario-icon-alert-success"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.4-1.4 3.6 3.58L17.17 7l1.4 1.42L10 17z",
    fill: "#118847"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 12l5 5 8.58-8.58L17.17 7 10 14.17 6.4 10.6 5 12z",
    fill: "#fff"
  }))), _symbol7 || (_symbol7 = /*#__PURE__*/React.createElement("symbol", {
    id: "ontario-icon-alert-warning"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z",
    fill: "#ffd440"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 10h2v4h-2zm0 6h2v2h-2z",
    fill: "#000"
  }))), _symbol8 || (_symbol8 = /*#__PURE__*/React.createElement("symbol", {
    id: "ontario-icon-chevron-down"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.4 8.6l4.6 4.58 4.6-4.58L18 10l-6 6-6-6 1.4-1.4z",
    fill: ""
  }))), _symbol9 || (_symbol9 = /*#__PURE__*/React.createElement("symbol", {
    id: "ontario-icon-chevron-left"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.4 7.4L14 6l-6 6 6 6 1.4-1.4-4.58-4.6 4.58-4.6z",
    fill: ""
  }))), _symbol0 || (_symbol0 = /*#__PURE__*/React.createElement("symbol", {
    id: "ontario-icon-chevron-right"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 6L8.6 7.4l4.58 4.6-4.58 4.6L10 18l6-6-6-6z",
    fill: ""
  }))), _symbol1 || (_symbol1 = /*#__PURE__*/React.createElement("symbol", {
    id: "ontario-icon-chevron-up"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.4 15.4l4.6-4.58 4.6 4.58L18 14l-6-6-6 6 1.4 1.4z",
    fill: ""
  }))), _symbol10 || (_symbol10 = /*#__PURE__*/React.createElement("symbol", {
    id: "ontario-icon-close"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 6.4L17.6 5 12 10.6 6.4 5 5 6.4l5.6 5.6L5 17.6 6.4 19l5.6-5.6 5.6 5.6 1.4-1.4-5.6-5.6L19 6.4z",
    fill: ""
  }))), _symbol11 || (_symbol11 = /*#__PURE__*/React.createElement("symbol", {
    id: "ontario-icon-collapse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 13H5v-2h14v2z",
    fill: ""
  }))), _symbol12 || (_symbol12 = /*#__PURE__*/React.createElement("symbol", {
    id: "ontario-icon-credit-card"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z",
    fill: ""
  }))), _symbol13 || (_symbol13 = /*#__PURE__*/React.createElement("symbol", {
    id: "ontario-icon-critical-alert-warning"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "",
    d: "M11 10h2v4h-2zM11 16h2v2h-2z"
  }))), _symbol14 || (_symbol14 = /*#__PURE__*/React.createElement("symbol", {
    id: "ontario-icon-dropdown-arrow"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.965 10a.4.4 0 00-.37.247.4.4 0 00.087.436l4.035 4.035a.4.4 0 00.566 0l4.035-4.035a.4.4 0 00.087-.436.4.4 0 00-.37-.247h-8.07z",
    fill: "#1a1a1a"
  }))), _symbol15 || (_symbol15 = /*#__PURE__*/React.createElement("symbol", {
    id: "ontario-icon-email"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z",
    fill: ""
  }))), _symbol16 || (_symbol16 = /*#__PURE__*/React.createElement("symbol", {
    id: "ontario-icon-expand"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z",
    fill: ""
  }))), _symbol17 || (_symbol17 = /*#__PURE__*/React.createElement("symbol", {
    id: "ontario-icon-help"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.6-.86.6-1.4 0-1.1-.9-2-2-2s-2 .9-2 2H8a4 4 0 118 0 3.18 3.18 0 01-.93 2.25z",
    fill: ""
  }))), _symbol18 || (_symbol18 = /*#__PURE__*/React.createElement("symbol", {
    id: "ontario-icon-menu"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z",
    fill: ""
  }))), _symbol19 || (_symbol19 = /*#__PURE__*/React.createElement("symbol", {
    id: "ontario-icon-new-window"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 19H5V5h7V3H5a2 2 0 00-2 2v14a2 2 0 002 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.6l-9.83 9.83 1.4 1.4L19 6.4V10h2V3h-7z",
    fill: ""
  }))), _symbol20 || (_symbol20 = /*#__PURE__*/React.createElement("symbol", {
    id: "ontario-icon-phone"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 15.38c-1.23 0-2.42-.2-3.53-.56a.956.956 0 00-1 .24l-1.57 1.97c-2.83-1.35-5.48-3.9-6.9-6.83l1.95-1.66a1.02 1.02 0 00.24-1.02c-.37-1.1-.56-2.3-.56-3.53A1 1 0 007.65 3H4.2C3.65 3 3 3.24 3 4c0 9.3 7.73 17 17 17 .7 0 1-.63 1-1.18v-3.45a1 1 0 00-.99-.99z",
    fill: ""
  }))), _symbol21 || (_symbol21 = /*#__PURE__*/React.createElement("symbol", {
    id: "ontario-icon-remove-alt"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11H7v-2h10v2z",
    fill: ""
  }))), _symbol22 || (_symbol22 = /*#__PURE__*/React.createElement("symbol", {
    id: "ontario-icon-remove"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 11v2h10v-2H7zm5-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.4 0-8-3.6-8-8s3.6-8 8-8 8 3.6 8 8-3.6 8-8 8z",
    fill: ""
  }))), _symbol23 || (_symbol23 = /*#__PURE__*/React.createElement("symbol", {
    id: "ontario-icon-search"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5 14h-.8l-.28-.27A6.47 6.47 0 0016 9.5a6.5 6.5 0 10-13 0A6.5 6.5 0 009.5 16a6.47 6.47 0 004.23-1.57l.27.28v.8l5 5 1.5-1.5-5-5zm-6 0C7 14 5 12 5 9.5S7 5 9.5 5 14 7 14 9.5 12 14 9.5 14z",
    fill: ""
  }))), _symbol24 || (_symbol24 = /*#__PURE__*/React.createElement("symbol", {
    id: "ontario-icon-tty"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.2 6.056c5.41-5.41 14.177-5.403 19.58 0a.716.716 0 01.1.886l-1.688 2.7c-.09.142-.225.25-.385.3s-.333.047-.488-.016l-3.376-1.35a.713.713 0 01-.446-.736l.232-2.325a11.07 11.07 0 00-7.48 0l.233 2.325c.015.155-.02.3-.1.443s-.202.236-.346.293L4.67 9.928a.718.718 0 01-.873-.284L2.11 6.94a.71.71 0 01.101-.885zm3.54 7.976V12.47a.47.47 0 00-.459-.47H3.72a.47.47 0 00-.469.469v1.563a.47.47 0 00.469.469h1.56a.47.47 0 00.469-.469zm3.75 0V12.47a.47.47 0 00-.459-.47H7.47a.47.47 0 00-.469.469v1.563a.47.47 0 00.469.469h1.56a.47.47 0 00.469-.469zm3.75 0V12.47a.47.47 0 00-.469-.469H11.22a.47.47 0 00-.469.469v1.563a.47.47 0 00.469.469h1.563a.47.47 0 00.469-.469zm3.75 0V12.47a.47.47 0 00-.469-.469H14.97a.47.47 0 00-.469.469v1.563a.47.47 0 00.469.469h1.563a.47.47 0 00.469-.469zm3.75 0V12.47a.47.47 0 00-.469-.469H18.72a.47.47 0 00-.469.469v1.563a.47.47 0 00.469.469h1.563a.47.47 0 00.469-.469zM7.625 17.78v-1.56a.47.47 0 00-.469-.469H5.594a.47.47 0 00-.469.469v1.563a.47.47 0 00.469.469h1.563a.47.47 0 00.469-.469zm3.75 0v-1.56a.47.47 0 00-.469-.469H9.344a.47.47 0 00-.469.469v1.563a.47.47 0 00.469.469h1.563a.47.47 0 00.469-.469zm3.75 0v-1.56a.47.47 0 00-.469-.469h-1.562a.47.47 0 00-.469.469v1.563a.47.47 0 00.469.469h1.563a.47.47 0 00.469-.469zm3.75 0v-1.56a.47.47 0 00-.469-.469h-1.562a.47.47 0 00-.469.469v1.563a.47.47 0 00.469.469h1.563a.47.47 0 00.469-.469zM5.75 21.53v-1.56a.47.47 0 00-.469-.469H3.72a.47.47 0 00-.469.469v1.563a.47.47 0 00.469.469h1.56a.47.47 0 00.469-.469zm11.25 0v-1.56a.47.47 0 00-.469-.469H7.47a.47.47 0 00-.469.469v1.563a.47.47 0 00.469.469h9.063a.47.47 0 00.469-.469zm3.75 0v-1.56a.47.47 0 00-.469-.469H18.72a.47.47 0 00-.469.469v1.563a.47.47 0 00.469.469h1.563a.47.47 0 00.469-.469z",
    fill: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOntarioIconsPrimary);
export default __webpack_public_path__ + "static/media/ontario-icons-primary.3322515026f8786ac3909771adef3504.svg";
export { ForwardRef as ReactComponent };